import {
  gql
} from "@apollo/client";

export const FORM_DOCUMENTS = gql`
{
    formDocuments {
      data {
        id
        attributes {
                  documents {
            title
            description
            document {
              data {
                attributes {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const SLIDERS = gql`
{
	sliders{
    data{
      id
      attributes{
        title
        description
        link
        image{
          data{
            attributes{
              url
            }
          }
        }
      }
    }
  }
}
`;

export const LOGIN_MUTATION = gql`
    mutation ($identifier: String!, $password: String!) {
      login(input : {identifier : $identifier  , password : $password }) {
        jwt
        user{
          username
          role {
            name
          }
          email
          id
          full_name
          mobile_number
          mobile_verified
          documents_status
          docs_validate_message
          confirmed
          email_verified
          is_company
        }
      }
    }
`;

export const REGISTER_MUTATION = gql`
  mutation ($username: String!, $email: String! , $password: String!) {
    register(input : {username : $username , email : $email  , password : $password }) {
      jwt
      user{
        username
        role {
          name
        }
        email
        id
        full_name
        mobile_number
        mobile_verified
        documents_status
        docs_validate_message
        confirmed
        email_verified
        is_company
      }
    }
  }
`;

export const UPDATE_USERINFO = gql`
mutation($id : ID! , $full_name : String! , $mobile_number : String!  , $nation_code : String! , $is_company : Boolean!){
  updateUsersPermissionsUser(id : $id , data : {
   	full_name : $full_name
    mobile_number : $mobile_number
    nation_code : $nation_code
    is_company : $is_company
  }){
    data{
      attributes{
        mobile_number
        full_name
        nation_code
        is_company
      }
    }
  }
}
`;

export const ME = gql`
{
  me {
      username
      role {
        name
      }
      email
      id
      full_name
      mobile_number
      mobile_verified
      documents_status
      docs_validate_message
      confirmed
      email_verified
      is_company
    }
}
`;

export const PERSONAL_DOCS = gql`
{
  personalDocuments {
    data {
      id
      attributes {
        document {
          data {
            id
            attributes {
              url
              ext
            }
          }
        }
      }
    }
  }
}
`;

export const UPLOAD_MUTATION = gql`
mutation($file: Upload!) {
  upload(file: $file) {
    data {
      id
      attributes {
        name
        url
      }
    }
  }
}
`;

export const USD_PRICE = gql`
{
  prices(sort :"createdAt:desc" , pagination :{limit :2} , filters :{currency : { en_name : { eq : "usd"}}}){
    data{
      attributes{
        sell
        buy
        updatedAt
      }
    }
  } 
}`;


export const EUR_PRICE = gql`
{
  prices(sort :"createdAt:desc" , pagination :{limit :2} , filters :{currency : { en_name : { eq : "eur"}}}){
    data{
      attributes{
        sell
        buy
        updatedAt
      }
    }
  } 
}`;

export const CURRENCIES = gql`
{
  currencies{
    data{
      attributes{
        flag{
          data{
            attributes{
              url
            }
            id
          
          }
        }
        fa_name
        en_name
      }
    }
  }
}
`;

export const FIND_PRICE_BY_CURRENCY = gql`
query($currency : String!){
  prices(sort :"createdAt:desc" , pagination :{limit :2} , filters :{currency : { en_name : { eq : $currency}}}){
    data{
      attributes{
        sell
        buy
        updatedAt
      }
    }
  } 
}`;

export const CUSTOMER_COMPANIES = gql`
{
  customerCompany{
    data{
      attributes{
        logo{
          data{
            attributes{
              url
            }
          }
        }
      }
    }
  }
}
`;